
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image, Tracking } from 'contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Die Fachblätter «Arznei-Telegramm» und «Pharma-Kritik» kritisieren, dass die neuen Medikamente nicht mit erprobten Vorbeugemedikamenten verglichen wurden, sondern nur mit Placebo – und da sei der Vorteil «verhältnismässig bescheiden». Insbesondere, wenn man die Kosten berücksichtige: rund 8000 Franken Jahreskosten für die neuen Spritzen im Vergleich zu 160 Franken pro Jahr für einen bewährten Betablocker. Ausserdem, geben sie zu bedenken, wisse man noch wenig zur Langzeitverträglichkeit. Sie raten, die Mittel nur einzusetzen, wenn alle anderen Optionen erfolglos waren oder nicht möglich sind.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;